<template>
    <section class="home">
        <nav class="nav">
            <navBar/>
        </nav>
        <section class="home_container">
            <v-siderbar></v-siderbar>
            <section class="home_content_wrapper">
                <v-tags></v-tags>
                <section class="content">
                    <div class="content_scroll">
                        <transition
                            name="slide"
                            mode="out-in">
                            <keep-alive :include="tagsList">
                                <router-view></router-view>
                            </keep-alive>
                        </transition>
                    </div>
                </section>
            </section>
        </section>
    </section>
</template>

<script>
    import home from './home.js';

    export default {
        ...home
    };
</script>

<style src="./home.css" scoped></style>



// WEBPACK FOOTER //
// src/views/common/home/home.vue